<template>
    <div class="row text-center">
        <div class="col-12">
            <p class="mb-0"><small v-show="orderId !== null">Ordre ID: {{ orderId }}</small></p>
            <p class="mb-0"><small v-show="amount !== 0">Beløp: {{ displayAmount }} kr</small></p>
            <p class="fw-bold" :class="titleClasses" v-show="title">{{ title }}</p>
            <p>{{ description }}</p>

            <div class="text-center" v-show="inProgress">
                <span class="spinner-border" role="status"></span>
            </div>

            <div class="row justify-content-center mt-3">
                <div class="col-sm-6 col-12 order-1 order-sm-0 mb-1" v-show="!inProgress">
                    <a href="/" class="btn btn-secondary btn-block btn-sm-inline cursor-pointer">Gå til TABS</a>
                </div>
                <div class="col-sm-6 col-12 order-0 order-sm-1 mb-1 text-end" v-show="displayTryAgainButton">
                    <a :href="tryAgainLink" class="btn btn-primary btn-block btn-sm-inline">
                        Prøv igjen
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { toMoney } from '../../lib/format';
import Api from '../../api/Payment';

const props = defineProps(['vippsHash']);
const emit = defineEmits(['inprogress', 'error']);

const inProgress = ref(true);
const currentAttempt = ref(1);
const maxAttempts = ref(100);
const secondsBetweenEachCheck = ref(3);
const description = ref('');
const orderId = ref(null);
const displayTryAgainButton = ref(false);
const amount = ref(0);
const title = ref('');
const title_class = ref('');

const displayAmount = computed(() => toMoney(amount.value));
const titleClasses = computed(() => ({ [title_class.value]: true }));
const tryAgainLink = computed(() => '/v/' + props.vippsHash);

const checkStatus = () => {
    Api.GetVippsNoSessionTransactionStatus(props.vippsHash, {
        attempt: currentAttempt.value,
        max: maxAttempts.value
    }).then(res => {
        setVippsData(res.data);
        currentAttempt.value++;

        if (inProgress.value) {
            setTimeout(checkStatus, secondsBetweenEachCheck.value * 1000);
        }
    }).catch(e => {
        console.log(e);
    });
};

const setVippsData = (data) => {
    inProgress.value = data.inprogress;
    description.value = data.description;
    title.value = data.title;
    title_class.value = data.title_class;
    displayTryAgainButton.value = data.try_again_btn;
    if (data.amount) {
        amount.value = data.amount;
    }
    if (data.order_id) {
        orderId.value = data.order_id;
    }
};

onMounted(() => {
    checkStatus();
});
</script>
